
    <div class="ui-g-12 dashboard card card-w-title">
      <div class="ui-g-12 ui-grid-row">
        {{'products.select_product' | translate}}
      </div>
      <form (ngSubmit)="this.onNextClick()" #categoryChoiceForm="ngForm">
        <div class="ui-g-12 ui-grid-row">
          <p-dropdown [style]="{'width':'100%'}" [filter]="true" filterBy="label" [options]="this.categories" (onChange)="this.onChangeCategory($event)"></p-dropdown>
        </div>
        <div class="ui-g-12 ui-grid-row">
          <p-autoComplete name="autocomplete" [(ngModel)]="this.selectedArticles" [suggestions]="this.suggestedArticles"
                          (completeMethod)="this.onSearchItem($event)" [multiple]="true"
                          (onSelect)="this.checkLength($event)"
                          (onDropdownClick)="this.onSearchItem($event)"
                          [minLength]="2" field="descrizione_estesa"></p-autoComplete>
        </div>
      </form>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/products/article-choice.component.ts.ArticleChoiceComponent.html